import React, { useState, useEffect } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function Five({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName, setTableName] = useState("5.Details of outward supplies made during the financial year on which tax is not payable");
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const storedTableItemsJSON = localStorage.getItem('tableItems');
    if (!storedTableItemsJSON) {
      const defaultTableItems = {
        four_n: {},
        four_g1: {},
        four_g2: {}
      };
      localStorage.setItem('tableItems', JSON.stringify(defaultTableItems));
    }
  }, []);

  // const submitHandle = () => {
  //   updateTableData(tableName, tableData);
  //   setUnsavedChanges(false);
  //   setSaveDailogOpen(false);
  //   setSnackbarOpen(true);
  // };

  const submitHandle = () => {
    // Create a new array with calculated values for subtotal rows
    const dataToSubmit = tableData.map((item) => {
      const isSubTotalRow = [
        "(G) Sub-total (A to F above)",
        "(L) Sub-total (H to K above)",
        "(M) Turnover on which tax is not to be paid  (G + L) above",
        "(N) Total Turnover (including advances) (4N + 5M - 4G - 4G1) above"
      ].includes(item.name);

      if (!isSubTotalRow) {
        return item; // Return normal rows as-is
      }

      // For subtotal rows, compute values for all fields
      const fields = ['taxable_value', 'igst', 'cgst', 'sgst', 'cess'];
      const updatedItem = { ...item };

      fields.forEach((field) => {
        const calculatedValue = getSubTotalRowValue(item, field);
        if (calculatedValue !== '') {
          updatedItem[field] = calculatedValue;
        }
      });

      return updatedItem;
    });

    console.log(dataToSubmit);
    

    // Now send the fully computed data
    updateTableData(tableName, dataToSubmit);

    setUnsavedChanges(false);
    setSaveDailogOpen(false);
    setSnackbarOpen(true);
  };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0;
    }
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');
    const cleanedValue = parseRupee(value);
    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );
    setUnsavedChanges(true);
    setTimeout(() => {
      setTableData(prev => [...prev]);
    }, 0);
  };

  const formatRupee = (value, isManualType = false) => {
    if (isManualType && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }
    if (!value && value !== 0) return '';
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    let cleaned = value.replace(/[^0-9.-]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const getSubTotalRowValue = (item, key_name) => {
    const isTaxField = ['igst', 'cgst', 'sgst', 'cess'].includes(key_name);
    const isGLMRow = [
      "(G) Sub-total (A to F above)",
      "(L) Sub-total (H to K above)",
      "(M) Turnover on which tax is not to be paid  (G + L) above"
    ].includes(item.name);

    // Force empty for tax columns in G, L, M rows
    if (isGLMRow && isTaxField) {
      return ''; // Empty string → shows blank in UI
    }

    let value = 0;

    switch (item.name) {
      case "(G) Sub-total (A to F above)":
        for (let i = 0; i < 7; i++) {
          value += safeParseFloat(tableData[i][key_name]);
        }
        return value;

      case "(L) Sub-total (H to K above)":
        for (let i = 8; i < 12; i++) {
          if (i === 8 || i === 11) {
            value -= safeParseFloat(tableData[i][key_name]);
          } else {
            value += safeParseFloat(tableData[i][key_name]);
          }
        }
        return value;

      case "(M) Turnover on which tax is not to be paid  (G + L) above":
        let l_value = 0;
        let g_value = 0;
        for (let i = 8; i < 12; i++) {
          if (i === 8 || i === 11) {
            l_value -= safeParseFloat(tableData[i][key_name]);
          } else {
            l_value += safeParseFloat(tableData[i][key_name]);
          }
        }
        for (let i = 0; i < 7; i++) {
          g_value += safeParseFloat(tableData[i][key_name]);
        }
        return parseFloat(l_value) + parseFloat(g_value);

      case "(N) Total Turnover (including advances) (4N + 5M - 4G - 4G1) above":
        const storedTableItemsJSON = localStorage.getItem('tableItems');
        const storedTableItems = storedTableItemsJSON ? JSON.parse(storedTableItemsJSON) : null;
        const fourN = storedTableItems?.four_n?.[key_name] || 0;
        const fourG = storedTableItems?.four_g1?.[key_name] || 0;
        const fourG1 = storedTableItems?.four_g2?.[key_name] || 0;

        if (key_name === 'taxable_value') {
          let l_value = 0;
          let g_value = 0;
          for (let i = 8; i < 12; i++) {
            if (i === 8 || i === 11) {
              l_value -= safeParseFloat(tableData[i][key_name]);
            } else {
              l_value += safeParseFloat(tableData[i][key_name]);
            }
          }
          for (let i = 0; i < 7; i++) {
            g_value += safeParseFloat(tableData[i][key_name]);
          }
          const m_val = g_value + l_value;
          return parseFloat(fourN) + m_val - parseFloat(fourG) - parseFloat(fourG1);
        } else {
          return parseFloat(fourN) - parseFloat(fourG) - parseFloat(fourG1);
        }

      default:
        return value;
    }
  };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isSubTotalRow = [
        "(G) Sub-total (A to F above)",
        "(L) Sub-total (H to K above)",
        "(M) Turnover on which tax is not to be paid  (G + L) above",
        "(N) Total Turnover (including advances) (4N + 5M - 4G - 4G1) above"
      ].includes(item.name);

      return (
        <div key={index} style={{
          display: 'grid',
          gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
          gap: '10px',
          alignItems: 'center',
          padding: '8px 10px',
          borderBottom: '1px solid #f1f5f9',
          backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
          borderRadius: '6px',
          marginBottom: '2px',
          minHeight: '50px'
        }}>
          <span style={{
            color: '#1e293b',
            fontSize: '13px',
            fontWeight: '600',
            textAlign: 'center',
            padding: '8px 6px',
            backgroundColor: getRowColor(index),
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {index + 1}
          </span>
          <span style={{
            color: '#334155',
            fontSize: '13px',
            padding: '8px 12px',
            backgroundColor: '#f1f5f9',
            borderRadius: '6px',
            wordBreak: 'break-word',
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            minHeight: '34px'
          }}>
            {item.name}
          </span>
          {['taxable_value', 'igst', 'cgst', 'sgst', 'cess'].map((field, idx) => {
            const isTaxField = ['igst', 'cgst', 'sgst', 'cess'].includes(field);
            const isRowNonEditableTax = index <= 13 && isTaxField;
            let displayValue;

            if (isSubTotalRow) {
              const liveValue = getSubTotalRowValue(item, field);
              displayValue = liveValue === '' ? '' : formatRupee(liveValue);
            } else if (isRowNonEditableTax) {
              displayValue = '';
            } else if (item.manual_type) {
              const rawVal = item[field];
              const numVal = safeParseFloat(rawVal);
              const stringVal = String(rawVal || '');
              displayValue = (rawVal === '' || rawVal === '-' || stringVal.endsWith('.')) ? rawVal : formatRupee(numVal, true);
            } else {
              displayValue = formatRupee(item[field], item.manual_type) || '';
            }

            return (
              <input
                key={`${item.name}.${field}`}
                type="text"
                className='blue-color'
                name={`${item.name}.${field}`}
                value={displayValue}
                onChange={handleInputChange}
                readOnly={isSubTotalRow || !item.manual_type || isRowNonEditableTax}
                style={{
                  color: isRowNonEditableTax ? '#625e5eff' : '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '8px 12px',
                  backgroundColor:
                    isRowNonEditableTax
                      ? '#bbb8b8ff'
                      : (isSubTotalRow || !item.manual_type ? '#f0f0f0' : '#ecfdf5'),
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  outline: 'none',
                  cursor: isSubTotalRow || !item.manual_type || isRowNonEditableTax ? 'not-allowed' : 'text',
                  minHeight: '34px',
                  boxSizing: 'border-box',
                  width: '100%',
                  ...(isSubTotalRow && !isRowNonEditableTax ? { fontWeight: 'bold', borderColor: 'green', borderWidth: '2px' } : {}),
                  ...(isSubTotalRow && isRowNonEditableTax ? { fontWeight: 'bold' } : {})
                }}
                onFocus={(e) => {
                  if (!isSubTotalRow && item.manual_type && !isRowNonEditableTax) {
                    const rawVal = item[field] || '';
                    e.target.value = rawVal;
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  if (!isSubTotalRow && item.manual_type && !isRowNonEditableTax) {
                    const rawVal = e.target.value;
                    const cleanedVal = parseRupee(rawVal);
                    const numVal = safeParseFloat(cleanedVal);
                    const stringVal = String(cleanedVal || '');
                    const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                    e.target.value = finalDisplay;
                    setTableData((prevData) =>
                      prevData.map((it) =>
                        it.name === item.name
                          ? { ...it, [field]: cleanedVal }
                          : it
                      )
                    );
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              />
            );
          })}
        </div>
      );
    });
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '30px',
        width: '100%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
      }}>
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>
        <div style={{
          maxHeight: 'calc(100vh - 450px)',
          overflowY: 'auto',
          marginTop: '10px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '2px solid #e2e8f0',
            backgroundColor: '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
            fontWeight: '600',
            color: '#475569',
            fontSize: '13px',
            position: 'sticky',
            top: '0',
            zIndex: '10'
          }}>
            <span style={{
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: '#e0e7ff',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>S.No.</span>
            <span style={{
              textAlign: 'left',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              display: 'flex',
              alignItems: 'center'
            }}>Nature of Supplies</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Taxable value (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Integrated Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>Central Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>State/UT Tax (₹)</span>
            <span style={{
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>CESS (₹)</span>
          </div>
          {(tableData && tableData.length >= 1) ? renderTableRows() : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>
        <div style={{
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#f8fafc',
          borderRadius: '8px',
          borderTop: '2px solid #e2e8f0'
        }}>
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          gap: '10px'
        }}>
          <button
            type="button"
            className='button-primary'
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>
      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />
      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Five;